import moment from "moment";

const istDate = (d) => {
  const m = moment(d).utcOffset("+0530");
  return new Date(m.year(), m.month(), m.date());
};

export const date = istDate(new Date());

export const localDate = (d) => {
  if (d) return istDate(d);
};

export const handleDatePickerFocus = (event) => {
  const input = event.target;
  input.setSelectionRange(0, 2);
};
